import React, { useState, useEffect, useRef } from 'react';
import logo from '../img/logo-softmining.svg';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import {
    queryMolecules,
    enqueueRdkitRequest,
    getRdkitRequestStatus
} from '../Utility/MoleculeDB/moleculeDBUtils';
import Header from "../components/header";
import Slider from 'react-slider';
import '../css/rangeSlider.css';
import '../css/moleculeCard.css';
import { retrieveMineData, consumeToken } from '../Utility/ConsumeToken/consumeToken';

function MoleculeCard({ smiles, id, mwt, logp, atomNumbers, imageReady, Open }) {
    const safeName = smiles.replace(/\//g, '%SLASH%').replace(/\\/g, '%SLASH%');
    const imgFile = encodeURIComponent(safeName) + '.png';
    const imgUrl = `https://molecules.softmining.it/mol_images/${imgFile}`;

    console.log("Rendering MoleculeCard for:", smiles, "Image URL:", imgUrl, "Image Ready:", imageReady);
    return (
        <>
        <div className="cardMolecule">
            {imageReady ? (
                <img
                    src={imgUrl}
                    alt={smiles}
                    className="imgMoleculeCard"
                />
            ) : (
                <div className="loadingImage">
                    <span>Loading image…</span>
                </div>
            )}
            <div className='cardMoleculeData'>
                <p className='smileCardMolecule'><strong>SMILES:</strong><br />{smiles}</p>
                <p>
                    <button className="button buttonUser" onClick={Open}>
                        Show Details
                    </button>
                </p>
            </div>
        </div>
        </>
    );
}

export default function MoleculeDB() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [results, setResults] = useState([]);
    const [visibleCount, setVisibleCount] = useState(20);
    const [imageReadyMap, setImageReadyMap] = useState({});
    const [hasSearched, setHasSearched] = useState(false);
    const [pageNum, setPageNum] = useState(1);
    const [hasMoreResults, setHasMoreResults] = useState(true);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedMol, setSelectedMol] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const handleOpenDetailsModal = (mol) => {
        setSelectedMol(mol);
        setShowDetailsModal(true);
    };

    const handleCloseDetailsModal = () => {
        setShowDetailsModal(false);
        setSelectedMol(null);
    };


    // Input per valori range
    const [smileQuery, setSmileQuery] = useState('');
    const minW = 51;
    const maxW = 1079;
    const minL = -18;
    const maxL = 25;
    const minA = 4;
    const maxA = 78;
    const [weight, setWeight] = useState([minW, maxW]);
    const [logP, setLogP] = useState([minL, maxL]);
    const [atomN, setAtomN] = useState([minA, maxA]);

    const enqueuedRef = useRef(new Set());
    const jobsRef = useRef({});

    useEffect(() => {
        if (!hasSearched) return;
        const visibleSmiles = results.slice(0, visibleCount).map(m => m.smiles);
        const toEnqueue = visibleSmiles.filter(smi => !enqueuedRef.current.has(smi));
        if (!toEnqueue.length) return;
        const apitoken = retrieveMineData();
        enqueueRdkitRequest(toEnqueue, apitoken._id)
            .then(res => {
                const jid = res.result;
                jobsRef.current[jid] = toEnqueue;
                toEnqueue.forEach(smi => enqueuedRef.current.add(smi));
                const interval = setInterval(async () => {
                    try {
                        const status = await getRdkitRequestStatus(jid);
                        if (status.output === "ITEM NOT FOUND" && status.result === -1) {
                            setImageReadyMap(prev => {
                                const next = { ...prev };
                                jobsRef.current[jid].forEach(smi => next[smi] = true);
                                return next;
                            });
                            clearInterval(interval);
                        }
                    } catch (err) {
                        console.error("Errore polling RDKit status:", err);
                    }
                }, 2000);
            })
            .catch(err => console.error("Errore enqueue RDKit:", err));
    }, [results, visibleCount, hasSearched]);

    const toNumber = str => Number(str);
    const W = [toNumber(weight[0]), toNumber(weight[1])];
    const LogP = [toNumber(logP[0]), toNumber(logP[1])];
    const AtomN = [toNumber(atomN[0]), toNumber(atomN[1])];

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setPageNum(1);
        setHasMoreResults(true);

        try {
            const apitoken = await retrieveMineData();
            console.log(W, LogP, AtomN);
            if (apitoken.tokens > 1) {
                // await consumeToken(-2);
                const data = await queryMolecules({
                    serviceName: "MOLECULES_QUERY",
                    IDD: apitoken._id,
                    Token: "000111",
                    W, LogP, AtomN,
                    Smile: smileQuery,
                    pageNum: pageNum
                });
                if (data.output === "COMPLETED" && data.result) {
                    const arr = Object.entries(data.result).map(([smiles, info]) => ({
                        smiles,
                        mwt: info.mwt,
                        logp: info.logp,
                        atomNumbers: info.atom_numbers
                    }));
                    setResults(arr);
                    setVisibleCount(arr.length);
                    setImageReadyMap({});
                    enqueuedRef.current.clear();
                    jobsRef.current = {};
                    setHasSearched(true);
                } else {
                    setError("Query Error.");
                    setResults([]);
                }
            } else {
                alert("Insufficient token");
            }
        } catch (err) {
            console.error(err);
            setError("Execution Query Error.");
            setResults([]);
        }
        setLoading(false);
    };

    const handleLoadMore = async () => {
        if (!hasMoreResults) return;
        setLoading(true);
        setError(null);

        try {
            const apitoken = await retrieveMineData();
            const nextPage = pageNum + 1;
            const data = await queryMolecules({
                serviceName: "MOLECULES_QUERY",
                IDD: apitoken._id,
                Token: "000111",
                W, LogP, AtomN,
                Smile: smileQuery,
                pageNum: nextPage
            });

            if (data.output === "COMPLETED" && data.result) {
                const arr = Object.entries(data.result).map(([smiles, info]) => ({
                    smiles,
                    mwt: info.mwt,
                    logp: info.logp,
                    atomNumbers: info.atom_numbers
                }));

                if (arr.length === 0) {
                    setHasMoreResults(false);
                } else {
                    // accodo i nuovi risultati
                    setResults(prev => [...prev, ...arr]);
                    // incremento pagina
                    setPageNum(nextPage);
                    // incremento anche il numero visibile
                    setVisibleCount(prev => prev + arr.length);
                }
            } else {
                setHasMoreResults(false);
            }
        } catch (err) {
            console.error(err);
            setError("Execution Query Error.");
        }

        setLoading(false);
    };

    // Responsive sidebar behavior
      useEffect(() => {
        const handleResize = () => {
          if (window.innerWidth > 1100) {
            setIsSidebarOpen(true);   // su desktop sidebar sempre aperta
          } else {
            setIsSidebarOpen(false);  // su mobile parte chiusa
          }
        };
    
        handleResize(); // inizializza in base alla larghezza attuale
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);


    const visibleResults = results.slice(0, visibleCount);

    if (!hasSearched) {
        return (
            <>
                <Header />
                    <div className="riga headerTools">
                        <h3 className="titolo titoloFeature">MolSeeker</h3>
                        <p className="text description">
                            MolSeeker identifies molecules starting from a user-defined SMILES string. The tool allows filtering of the resulting set by molecular weight range, atom count range, and logP range.
                        </p>
                        <div className="space"></div>
                    </div>
                    <center>
                    <div className="form formSignup formTools">
                        <img src={logo} className="sign-logo" alt="logo" />
                        <span className="titolo"><center>SEARCH FILTERS</center></span>
                        <form onSubmit={handleSubmit}>
                            <div className="inputLeft">
                                <label>SMILES:</label>
                                <input
                                    type="text"
                                    value={smileQuery}
                                    onChange={e => setSmileQuery(e.target.value)}
                                    placeholder="Ex: O=[N+]"

                                />
                            </div>
                            <div className="inputRight">
                                <label>Weight Range:</label>
                                <Slider
                                    className="slider"
                                    value={weight}
                                    onChange={(newWeight) => setWeight(newWeight)}
                                    min={minW}
                                    max={maxW}
                                    step={1}
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                                    <div>
                                        <input
                                            type="text"
                                            min={minW}
                                            max={maxW}
                                            className="inputSliderRange"
                                            value={weight[0]}
                                            onChange={e => {
                                                const v = Number(e.target.value);
                                                setWeight([Math.min(v, weight[1]), weight[1]]);
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            min={minW}
                                            max={maxW}
                                            className="inputSliderRange"
                                            value={weight[1]}
                                            onChange={e => {
                                                const v = Number(e.target.value);
                                                setWeight([weight[0], Math.max(v, weight[0])]);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="space"></div>
                                <div className="spaceGraph"></div>
                            </div>

                            <div className="inputLeft">
                                <label>LogP Range:</label>
                                <Slider
                                    className="slider"
                                    value={logP}
                                    onChange={(newLogP) => setLogP(newLogP)}
                                    min={minL}
                                    max={maxL}
                                    step={1}
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div>
                                        <input
                                            type="text"
                                            min={minL}
                                            max={maxL}
                                            className="inputSliderRange"
                                            value={logP[0]}
                                            onChange={e => {
                                                const v = Number(e.target.value);
                                                setLogP([Math.min(v, logP[1]), logP[1]]);
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            min={minL}
                                            max={maxL}
                                            className="inputSliderRange"
                                            value={logP[1]}
                                            onChange={e => {
                                                const v = Number(e.target.value);
                                                setLogP([logP[0], Math.max(v, logP[0])]);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="space"></div>
                            </div>

                            <div className="inputRight">
                                <label>Atoms Number Range:</label>
                                <Slider
                                    className="slider"
                                    value={atomN}
                                    onChange={(newatomN) => setAtomN(newatomN)}
                                    min={minA}
                                    max={maxA}
                                    step={1}
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div>
                                        <input
                                            type="text"
                                            min={minA}
                                            max={maxA}
                                            className="inputSliderRange"
                                            value={atomN[0]}
                                            onChange={e => {
                                                const v = Number(e.target.value);
                                                setAtomN([Math.min(v, atomN[1]), atomN[1]]);
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            min={minA}
                                            max={maxA}
                                            className="inputSliderRange"
                                            value={atomN[1]}
                                            onChange={e => {
                                                const v = Number(e.target.value);
                                                setAtomN([atomN[0], Math.max(v, atomN[0])]);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="space"></div>
                            </div>

                            <div>
                                <button type="submit" className="sign-button button" disabled={loading}>
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                        </form>

                        <div className="riga">
                            <Link className="textlink textLinkSign" to="/dashboard">Back to Dashboard <FaArrowRight size={12} style={{ marginLeft: '8px', marginBottom: '-1px' }} /></Link>
                        </div>
                    </div>
                <div className="space"></div>
                </center>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="riga headerTools">
                <h3 className="titolo titoloFeature">MolSeeker</h3>
                <p className="text description descriptionSidebarTools">
                    MolSeeker identifies molecules starting from a user-defined SMILES string. The tool allows filtering of the resulting set by molecular weight range, atom count range, and logP range.
                </p>
                <div className="space"></div>
                <button
                    type="button"
                    className="button sign-button sidebar-toggle"
                    onClick={() => setIsSidebarOpen(prev => !prev)}
                >
                    {isSidebarOpen ? 'Hide settings' : 'Show settings'}
                </button>
            </div>

            <div className={`ManageAreaSidebar ${isSidebarOpen ? 'is-open' : ''}`}>
                <span className="titolo searchTitle" ><center>SEARCH FILTERS</center></span>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label>SMILES:</label>
                        <input
                            type="text"
                            value={smileQuery}
                            onChange={e => setSmileQuery(e.target.value)}
                            placeholder="Ex: O=[N+]"

                        />
                    </div>

                    <div className="spaceGraph"></div>

                    <div>
                        <label>Weight Range:</label>
                        <Slider
                            className="slider"
                            value={weight}
                            onChange={(newWeight) => setWeight(newWeight)}
                            min={minW}
                            max={maxW}
                            step={1}
                        />
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
                            <div>
                                <input
                                    type="text"
                                    min={minW}
                                    max={maxW}
                                    className="inputSliderRange"
                                    value={weight[0]}
                                    onChange={e => {
                                        const v = Number(e.target.value);
                                        setWeight([Math.min(v, weight[1]), weight[1]]);
                                    }}
                                />
                            </div>
                            <div>
                                <input
                                    type="text"
                                    min={minW}
                                    max={maxW}
                                    className="inputSliderRange"
                                    value={weight[1]}
                                    onChange={e => {
                                        const v = Number(e.target.value);
                                        setWeight([weight[0], Math.max(v, weight[0])]);
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="spaceGraph"></div>
                    <div className="spaceGraph"></div>

                    <div>
                        <label>LogP Range:</label>
                        <Slider
                            className="slider"
                            value={logP}
                            onChange={(newLogP) => setLogP(newLogP)}
                            min={minL}
                            max={maxL}
                            step={1}
                        />
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
                            <div>
                                <input
                                    type="text"
                                    min={minL}
                                    max={maxL}
                                    className="inputSliderRange"
                                    value={logP[0]}
                                    onChange={e => {
                                        const v = Number(e.target.value);
                                        setLogP([Math.min(v, logP[1]), logP[1]]);
                                    }}
                                />
                            </div>
                            <div>
                                <input
                                    type="text"
                                    min={minL}
                                    max={maxL}
                                    className="inputSliderRange"
                                    value={logP[1]}
                                    onChange={e => {
                                        const v = Number(e.target.value);
                                        setLogP([logP[0], Math.max(v, logP[0])]);
                                    }}
                                />
                            </div>
                        </div>
                    </div>


                    <div className="spaceGraph"></div>
                    <div className="spaceGraph"></div>

                    <div>
                        <label>Atoms Number Range:</label>
                        <Slider
                            className="slider"
                            value={atomN}
                            onChange={(newatomN) => setAtomN(newatomN)}
                            min={minA}
                            max={maxA}
                            step={1}
                        />
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
                            <div>
                                <input
                                    type="text"
                                    min={minA}
                                    max={maxA}
                                    className="inputSliderRange"
                                    value={atomN[0]}
                                    onChange={e => {
                                        const v = Number(e.target.value);
                                        setAtomN([Math.min(v, atomN[1]), atomN[1]]);
                                    }}
                                />
                            </div>
                            <div>
                                <input
                                    type="text"
                                    min={minA}
                                    max={maxA}
                                    className="inputSliderRange"
                                    value={atomN[1]}
                                    onChange={e => {
                                        const v = Number(e.target.value);
                                        setAtomN([atomN[0], Math.max(v, atomN[0])]);
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="spaceGraph"></div>
                    <div className="spaceGraph"></div>

                    <div>
                        <button type="submit" className="button sign-button" disabled={loading}>
                            {loading ? "Loading..." : "Search"}
                        </button>
                    </div>

                    <div className="riga">
                        <Link className="textlink textLinkSign" to="/dashboard">Back to Dashboard <FaArrowRight size={12} style={{ marginLeft: '8px', marginBottom: '-1px' }} /></Link>
                    </div>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </form>
            </div>

            <div className="bodySearch">
                <hr style={{ width: '100%', margin: '0 0 15px 0' }} />
                <div className="bodySearchResults">
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', margin: '0 0 10px 0' }}>
                        {visibleResults.length > 0
                            ? visibleResults.map((mol) => (
                                <MoleculeCard
                                    key={mol.id}
                                    smiles={mol.smiles}
                                    id={mol.id}
                                    mwt={mol.mwt}
                                    logp={mol.logp}
                                    purchasable={mol.purchasable}
                                    atomNumbers={mol.atomNumbers}
                                    imageReady={!!imageReadyMap[mol.smiles]}
                                    Open={() => handleOpenDetailsModal(mol)}
                                />
                            ))
                            : <p>No results.</p>
                        }
                    </div>

                    {hasMoreResults && (
                        <div style={{ textAlign: 'center', margin: '20px 0' }}>
                            <button onClick={handleLoadMore} className="button buttonUser" disabled={loading}>
                                {loading ? "Loading..." : "Load More"}
                            </button>
                        </div>
                    )}
                    
                </div>
            </div>

            <div className='spaceGraph'></div>

            {showDetailsModal && selectedMol && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <div className="divCloseButton">
                            <button onClick={handleCloseDetailsModal} className="CloseButton text">X</button>
                        </div>
                        <div className="div50">
                            {/* immagine */}
                            <img
                                src={`https://molecules.softmining.it/mol_images/${encodeURIComponent(
                                    selectedMol.smiles.replace(/\//g, '%SLASH%').replace(/\\/g, '%SLASH%')
                                )}.png`}
                                alt={selectedMol.smiles}
                                style={{ width: '100%', height: 'auto' }}
                            />
                        </div>
                        <div className="div50 textLeft">
                            {/* dettagli */}
                            <p><strong>SMILES:</strong> {selectedMol.smiles}</p>
                            <p><strong>Weight:</strong> {selectedMol.mwt}</p>
                            <p><strong>LogP:</strong> {selectedMol.logp}</p>
                            <p><strong>Atoms Number:</strong> {selectedMol.atomNumbers}</p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
